import type { VoidComponent } from "solid-js";
import posthog from "posthog-js";
import { createGroupSchema } from "../../../state/group";
import { useTranslation } from "../../../state/i18n";
import InputModal from "../../../components/modal/InputModal";
import { TextInput } from "../../../components/inputs/TextInput";
import type { InferInput } from "valibot";
import { useCustomerState } from "../../../state/customer";
import { useModalManager } from "../../../components/modal/ModalManager";
import UserService from "../../../services/UserService";
import GenericFailureModal from "../../GenericFailureModal";
import { POSTHOG_EVENTS } from "../../../services/PostHogService";

const CreateGroupModal: VoidComponent = () => {
  const { t } = useTranslation();
  const customer = useCustomerState();
  const { replace } = useModalManager();

  const onConfirm = (value: InferInput<typeof createGroupSchema>) =>
    new Promise((resolve, reject) =>
      UserService.createGroup(customer.customerId).mutate(value, {
        onSuccess: (group) => {
          posthog.capture(POSTHOG_EVENTS.GROUP_CREATED);
          resolve(group);
        },
        onError: (err) => {
          replace({
            content: () => (
              <GenericFailureModal title={t(($) => $.CREATE_GROUP_MODAL_FAILURE_MODAL_TITLE)} error={err} />
            ),
          });
          reject(err);
        },
      }),
    );

  return (
    <InputModal
      variant="default"
      title={t(($) => $.CREATE_GROUP_MODAL_TITLE)}
      titleIcon="userGroup"
      cancelLabel={t(($) => $.CANCEL_BUTTON)}
      confirmLabel={t(($) => $.CREATE_GROUP_MODAL_ACTIONS_CONFIRM)}
      onConfirm={onConfirm}
      initialValue={{
        name: undefined,
      }}
      schema={createGroupSchema}
    >
      {({ value, updateValue, error }) => (
        <div class="flex flex-col gap-4">
          <TextInput
            label={t(($) => $.CREATE_GROUP_MODAL_MODAL_NAME)}
            value={value("name")}
            required
            onBlur={(e) => {
              updateValue("name", e.target.value);
            }}
            onInput={(e) => {
              updateValue("name", e.target.value);
            }}
            errorMessage={error("name")}
          />
        </div>
      )}
    </InputModal>
  );
};

export default CreateGroupModal;
